import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useDevices(project: string | null) {
  return useQuery({
    queryKey: ['devices', project],
    queryFn: () => api.getDevices(project!),
    enabled: !!project,
    refetchInterval: 30000,
  })
}
